module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maynard Solomon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Maynard Solomon's books on Beethoven and his renowned writings on Mozart, Schubert, and Ives led a contributor to "), _c('I', [_vm._v("Music & Letters")]), _vm._v(" to name him \"the leading musicologist-biographer of our time.\" His classic biography, "), _c('I', [_vm._v("Beethoven")]), _vm._v(", has been translated into seven languages and his "), _c('I', [_vm._v("Beethoven Essays")]), _vm._v(" received the Kinkeldey Award of the American Musicological Society for best book of the year in 1989. Mr. Solomon, who lives in New York, has taught at Columbia, Harvard, and Yale Universities.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Bw5hGZ/tc-custom/9780061856198.jpg?1718046751058",
      "alt": "This image is the cover for the book Mozart"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mozart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A finalist for the Pulitzer Prize for biography, this thoroughly researched study of the Classical composer deeply examines his life and work.")]), _c('br'), _c('br'), _vm._v("Considered one of the most important music biographies ever written, esteemed biographer Maynard Solomon draws on a half-century of new information to provide an in-depth account of Mozart’s family life, his passions, and his personality.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0